module.exports = __webpack_public_path__ + "static/media/ceny.25d856ba.jpg";